import type { Page, Pageable } from '../../../core/api/spring-types';
import { apiClient } from '../../../core/api/client';

/**
 * One row in the students leaderboard (clasament elevi pentru premiere).
 *
 * The backend returns rows already ordered by `total` descending, each with a
 * `loc` (dense rank on `total`) that represents the prize rank and stays fixed.
 * Per-column sorting is NOT performed by the backend — it must be done
 * client-side. See StudentsLeaderboardReportPage.
 */
export interface StudentLeaderboardRow {
    editionId: string;
    userId: string;                // link detalii elev (JSON only)
    schoolId?: string | null;      // link detalii școală (JSON only; poate fi null)
    loc: number;                   // dense rank pe total (rang de premiere, fix)
    nume: string;                  // poate fi poreclă sau email
    clasa: string;
    scoala: string;
    judet: string;
    email?: string;                // contact elev (lowercase; mereu setat)
    telefon?: string | null;       // contact elev (poate fi null)
    codProfesor?: string | null;   // cod profesor al ȘCOLII (poate fi null)
    puncteHomework: number;        // puncte teme
    puncteMonthly: number;         // puncte provocări lunare
    total: number;
}

/**
 * Students API - leaderboard endpoint not included in the generated SDK.
 * Uses apiClient directly (axios with Bearer-token interceptor + baseURL).
 */
class StudentsAPI {
    async getLeaderboard(
        filter: { editionId?: string },
        pageable: Pageable
    ): Promise<Page<StudentLeaderboardRow>> {
        const response = await apiClient.get<Page<StudentLeaderboardRow>>(
            '/api/students/leaderboard',
            { params: { ...filter, ...pageable } }
        );
        return response.data;
    }
}

export const studentsApi = new StudentsAPI();
